<template>
  <div v-if="!state.loading">
    <div class="pgehd">
        <h2>Assignment</h2>
    </div>
    <div class="grades">
        <router-link
            class="grade"
            v-for="grade in 16"
            :key="grade"
            :to="{ name: 'assignment', params: { sub: subject, grade: grade } }">
            Grade {{ grade }}
        </router-link>
        <router-link
            class="grade"
            :to="{ name: 'assignment', params: { sub: subject, grade: '17' } }">
            All Grades
        </router-link>
    </div>
  </div>
  <div v-else class="loader">
    <img src="@/assets/img/ajldr.gif" />
  </div>
  
</template>
<script>
import call from "../composables/call.js";
import { urls } from "../assets/js/urls.js";
import { onMounted, reactive, ref, computed} from 'vue';
import { useRoute } from "vue-router";

export default {
    name:"SubjectList",
    setup(){
        const route = useRoute();
        const subject = computed(() => route.params.subject);
        const state=reactive({loading:true})
        const list = ref([])
        const globalFilter=ref("")

        function setTable(d){
            if (!Array.isArray(d)) {
                list.value = Object.values(d)
            } else {
                list.value = d
            }
        }

        onMounted(() => {
            call({
                url:urls.subject,
                data:{getSubjectList:""},
                success:(res)=>{
                    state.loading=false
                    if(res.status){
                        setTable(res.msg.list)
                    }else{
                        alert(res.msg);
                    }
                }
            })
        });
        
        return {list,globalFilter, state,subject}
    }
}
</script>

<style scoped>
.grades{background: white; padding: 20px 0; display: flex; flex-wrap: wrap;}
.grades .grade{color: white; background: #3c8dbc; padding: 10px 20px; margin:5px;}
</style>